// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@sc/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { cartTotalStyles } from "@sc/Overrides/Widgets/Cart/CartTotal";
import { css } from "styled-components";

cartTotalStyles.container = {
    ...orderTotalDisplaySharedStyles.wrapper,
};

cartTotalStyles.actionsWrapper = {
    css: css`
        margin-top: 16px;
    `,
};

cartTotalStyles.checkoutButton = {
    sizeVariant: "large",
    variant: "primary",
    css: css`
        width: 100%;
    `,
};

cartTotalStyles.cancelPunchOutButton = {
    ...cartTotalStyles.cancelPunchOutButton,
    sizeVariant: "large",
};

cartTotalStyles.submitQuoteButton = {
    ...cartTotalStyles.submitQuoteButton,
    sizeVariant: "large",
};

cartTotalStyles.submitRequisitionButton = {
    ...cartTotalStyles.submitRequisitionButton,
    sizeVariant: "large",
};

cartTotalStyles.saveOrderApprovalButton = {
    sizeVariant: "large",
    variant: "primary",
    css: css`
        margin-top: 10px;
        width: 100%;
    `,
};
